import CommonBase from '../../settings/util/commonBase'

class LocationBaseController extends CommonBase {
  /*@ngInject*/
  constructor(Auth, $state, User, Service, Modal, $translate, $stateParams) {

    super(Auth, $state, User, Service, Modal, $translate, $stateParams)

    this.errors = {}
    this.loading = false
    this.errorMessage = ''
    this.model = {}
    this.toggleSwitchUI = {
      size: 'small',
      label: {
        on: 'Yes',
        off: 'No'
      },
      onColor: 'success',
      offColor: 'danger'
    }
  }

  askCreate() {
    return new Promise((resolve, reject) => {
      this.Modal.confirm({
        header: this.$translate.instant('location.create_another_title'),
        message: this.$translate.instant('location.create_another_message'),
        callback: ({
          modal,
          $scope
        }) => {
          this.reset();
          modal.close();
          resolve(true);
        },
        negative: ({
          modal,
          $scope
        }) => {
          modal.close();
          window.history.go(-1);
          resolve(false);
        },
        type: 'primary',
        buttons: ['common.yes', 'common.no']
      })
    })
  }
  reset() {
    // for (let key in this.model) {
    //   if (typeof (this.model[key]) == 'string') {
    //     this.model[key] = ''
    //   } else if (typeof (this.model[key]) == 'boolean') {
    //     this.model[key] = false
    //   } else {
    //     this.model[key] = ''
    //   }
    // }

    this.clearErrors()
  }

  validate() {
    this.clearErrors()
    for (let key in this.model) {
      if (!this.model[key] && typeof (this.model[key]) == 'string') {
        this.addError(key, key.charAt(0).toUpperCase() + key.slice(1) + ' is mandatory')
      }
    }

    return Object.keys(this.errors).length <= 0
  }

  clearErrors() {
    this.errors = {}
    this.errorMessage = ''
  }

  addError(id, message) {
    this.errors[id] = message
  }
}

export default LocationBaseController;


// WEBPACK FOOTER //
// ./client/app/components/location/common/location.base.controller.js